import { useClientsTabsPreview, getDevTabsSource } from "@/hooks/useClientsTabsPreview";

/**
 * Badge DEV visível e inconfundível
 * 
 * Mostra no canto inferior direito quando devTabs está ativo
 * Exibe:
 * - DEV TABS: ON
 * - Fonte de ativação (query, localStorage, env)
 * - Path atual
 * 
 * Apenas visual/diagnóstico - não afeta funcionalidade
 */
export default function DevTabsBadge() {
  const isEnabled = useClientsTabsPreview();
  const source = getDevTabsSource();

  // Não renderizar se flag não estiver ativa
  if (!isEnabled) {
    return null;
  }

  const sourceLabel = {
    query: "?devTabs=1",
    localStorage: "localStorage",
    env: "VITE_ENABLE_CLIENT_TABS_PREVIEW",
    disabled: "disabled",
  }[source];

  const path =
    typeof window !== "undefined" ? window.location.pathname : "unknown";

  return (
    <div
      className="fixed bottom-4 right-4 z-50 bg-gradient-to-r from-amber-400 to-amber-500 text-amber-950 px-4 py-3 rounded-lg shadow-lg border-2 border-amber-600 font-mono text-sm"
      style={{
        boxShadow: "0 0 20px rgba(251, 146, 60, 0.6)",
      }}
    >
      <div className="font-bold text-amber-950">🔧 DEV TABS: ON</div>
      <div className="text-xs text-amber-900 mt-1">
        source: {sourceLabel}
      </div>
      <div className="text-xs text-amber-900">path: {path}</div>
    </div>
  );
}
